<div *ngIf="errorMessage !== null">
    <small class="form-text control-message">{{errorMessage|async}}</small>
</div>
